import "./ConnectExchange.css";
import { storeUser } from "../../../../redux/users/usersSlice";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConnectedExchange from "./ConnectedExchange";
import Copy from "../../../../assets/images/Copy.svg";
import ProfileIcon from "../../../../assets/images/Profile.svg";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import TradeMarketSegment from "../../../sharedPages/CommonComponents/TradeMarketSegment/TradeMarketSegment";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import logo_black from "../../../../assets/images/onboardingImages/logo_black.svg";
import longArrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../../helpers/exchangeOAuth";
import { fetchUser } from "../../../../helpers/helper";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity";
import {
  parsePermissionType,
  resolveCommunityRecommendedPermissionType,
  cacheRecommendedPermissionType,
} from "../../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const MARKET_LABELS = {
  spot: "Spot",
  futures: "Futures",
  both: "Both (Spot & Futures)",
};

const ConnectExchange = () => {
  const [credentials, setCredentials] = useState({
    apiKey: "",
    exchange: "",
    secretKey: "",
  });
  const [isApiKeySelected, setisApiKeySelected] = useState(false);
  const [tradeMarketType, setTradeMarketType] = useState("both");
  const [recommendedPermissionType, setRecommendedPermissionType] =
    useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Exchange");
  const user = useSelector((value) => value?.user?.user);
  const [show, setShow] = useState(true);
  const api = useApi();
  const buttonRef = useRef(null);
  const modalBodyRef = useRef(null);
  const tradeMarketRef = useRef(null);
  const community = useSelector(
    (value) => value?.user?.user?.memberCommunities?.[0]?.community,
  );
  const hasAppliedRecommendation = useRef(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const communityName =
    community?.disPlayName || community?.name || "this community";

  const applyRecommendation = (recommended) => {
    if (!recommended) return;
    setRecommendedPermissionType(recommended);
    if (hasAppliedRecommendation.current) return;
    if (
      user?.binanceCredentials?.isConnected ||
      user?.bybitCredentials?.isConnected
    ) {
      return;
    }
    setTradeMarketType(recommended);
    hasAppliedRecommendation.current = true;
  };

  // Prefer the joined community's live market type as the recommended default.
  useEffect(() => {
    let cancelled = false;

    const loadRecommendedPermission = async () => {
      const communityId = community?._id;
      let recommended = null;

      if (communityId) {
        try {
          const response = await api("post", "NoLinkMember/allCommunities");
          const communities = response?.data?.communities || [];
          const matched = communities.find(
            (item) => String(item?._id) === String(communityId)
          );
          recommended = resolveCommunityRecommendedPermissionType(matched);
        } catch (error) {
          console.error("Failed to load community market recommendation:", error);
        }
      }

      if (!recommended) {
        recommended =
          resolveCommunityRecommendedPermissionType(community) ||
          parsePermissionType(
            sessionStorage.getItem("recommendedPermissionType")
          );
      }

      if (!cancelled && recommended) {
        applyRecommendation(recommended);
        cacheRecommendedPermissionType(communityId, recommended);
      }
    };

    loadRecommendedPermission();
    return () => {
      cancelled = true;
    };
  }, [
    community?._id,
    community?.permissionType,
    community?.bybitPermissionType,
    community?.binancePermissionType,
    community?.exchange,
  ]);

  useEffect(() => {
    if (!isApiKeySelected) return;

    const scrollExpandedFieldsIntoView = () => {
      const scroller = modalBodyRef.current;
      const target = tradeMarketRef.current;

      if (scroller && scroller.scrollHeight > scroller.clientHeight + 1) {
        scroller.scrollTo({ top: scroller.scrollHeight, behavior: "smooth" });
      }

      // Always reveal the new fields — covers cases where the outer
      // .modal / viewport is the scroll container, not the body.
      target?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    };

    const timers = [50, 180, 400].map((ms) =>
      window.setTimeout(scrollExpandedFieldsIntoView, ms)
    );
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [isApiKeySelected, selectedOption]);

  // Check if user is already connected to an exchange
  useEffect(() => {
    if (user) {
      // Check Binance connection
      if (user?.binanceCredentials?.isConnected) {
        setSelectedOption("Binance API Keys");
        setisApiKeySelected(true);
        if (
          user?.binanceCredentials?.permissionType === "spot" ||
          user?.binanceCredentials?.permissionType === "futures" ||
          user?.binanceCredentials?.permissionType === "both"
        ) {
          setTradeMarketType(user.binanceCredentials.permissionType);
        }
        setCredentials({
          apiKey: "********************************",
          secretKey: "********************************",
          exchange: "Binance"
        });
      }
      // Check Bybit connection
      else if (user?.bybitCredentials?.isConnected) {
        setSelectedOption("ByBit API Keys");
        setisApiKeySelected(true);
        if (
          user?.bybitCredentials?.permissionType === "spot" ||
          user?.bybitCredentials?.permissionType === "futures" ||
          user?.bybitCredentials?.permissionType === "both"
        ) {
          setTradeMarketType(user.bybitCredentials.permissionType);
        }
        setCredentials({
          apiKey: "********************************",
          secretKey: "********************************",
          exchange: "ByBit"
        });
      }
    }
  }, [user]);

  useEffect(() => {
    // if(user?.binanceCredentials?.isConnected||user?.bybitCredentials?.isConnected){
    //   setIsConnected(true);
    // }
    // BUG: onboarding.payment is a one-time "has this user ever paid" flag —
    // it stays true forever after their first community subscription, so a
    // member who unsubscribed and picked a NEW community from MarketPlace
    // got bounced straight to the dashboard here, skipping this connect
    // step and the subscribe/payment step entirely.
    // if (user?.onboarding?.connect && user?.onboarding?.payment) {
    //   navigate("/member/dashboard", { replace: true });
    // } else {
    //   setShow(true);
    // }
    if (
      user?.onboarding?.connect &&
      user?.memberCommunities?.[0]?.subscribed
    ) {
      navigate("/member/dashboard", { replace: true });
    } else {
      setShow(true);
    }
  }, []);

  const connectManually = async ({ apiKey, secretKey, exchange }) => {
    try {
      const response = await api("post", "binanceCredentials/create", {
        apiKey,
        exchange,
        secretKey,
        permissionType: tradeMarketType,
      });

      const { message, status } = response || {};

      if (status) {
        const responseUser = await api("get", "users/index");

        if (responseUser?.status) {
          const { data } = responseUser;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
          // return data;
        } else {
          dispatch(setRefetchSpecificUser(true));
        }
        setIsConnected(true);

        return setTimeout(() => {
          setIsConnected(false);
          navigate("/member/onboarding/subscription");
          // navigate("/member/onboarding/done");
        }, 3000);
      }

      toastify(message);
    } catch (error) {
      console.error("🚀 -> connectManually -> error:", error);
    }
  };

  const handleClose = () => {
    navigate("/member/dashboard", { replace: true });
    setShow(false);
  };
  
  const handleConnect = async () => {
    setIsLoading(true);
    if (selectedOption.includes("Quick Connect")) {
      selectedOption.split(" ")[0] === "Binance"
        ? oAuthBinance()
        : oAuthBybit();
    } else if (credentials.apiKey && credentials.secretKey) {
      // Don't proceed if it's just masked credentials (user already connected)
      if (
        credentials.apiKey.startsWith("**") &&
        credentials.secretKey.startsWith("**")
      ){
        setIsLoading(false);
        navigate("/member/onboarding/subscription");
        return;
      }
      await connectManually(credentials);
    }

    setIsLoading(false);
  };

  const handleOptionSelection = (option) => {
    setCredentials((pre) => ({ ...pre, exchange: option.split(" ")[0] }));
    setisApiKeySelected(option.includes("API Keys"));
    setIsDropdownOpen(false);
    setSelectedOption(option);
    
    // If user was previously connected and selects a different option, clear the masked credentials
    if (option.includes("API Keys")) {
      const exchange = option.split(" ")[0];
      const isBinanceConnected = user?.binanceCredentials?.isConnected && exchange === "Binance";
      const isBybitConnected = user?.bybitCredentials?.isConnected && exchange === "ByBit";
      
      if (isBinanceConnected || isBybitConnected) {
        setCredentials({
          apiKey: "**********",
          secretKey: "**********",
          exchange: exchange
        });
      } else {
        setCredentials({
          apiKey: "",
          secretKey: "",
          exchange: exchange
        });
      }
    } else {
      setCredentials({
        apiKey: "",
        secretKey: "",
        exchange: option.split(" ")[0]
      });
    }
  };

  const oAuthBinance = async () => {
    const userAgent = navigator.userAgent || "";
    const isSafariOnly =
      userAgent.includes("Safari") && !userAgent.includes("Chrome");

    setIsLoading(!isSafariOnly);
    redirectToBinanceOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const oAuthBybit = async () => {
    const userAgent = navigator.userAgent || "";
    const isSafariOnly =
      userAgent.includes("Safari") && !userAgent.includes("Chrome");

    localStorage.setItem("binanceCondition", "true");
    setIsLoading(!isSafariOnly);
    redirectToBybitOAuth({ permissionType: tradeMarketType, connectMode: true });
  };

  const toggleDropdown = () => setIsDropdownOpen((pre) => !pre);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      )
        setIsDropdownOpen(false);
    };

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal cmSide  connectExchnage"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow connect-exchange-modal-body">
          {isConnected ? (
            <div className="connect-exchange-scroll">
              <ConnectedExchange community={community} />
            </div>
          ) : (
            <>
              <button
                className="reverseArrow"
                onClick={() =>
                  navigate("/member/onboarding/view", { replace: true })
                }
                type="button"
              >
                <img alt="" src={longArrow} />
              </button>
              <button className="CrossIcon" onClick={handleClose} type="button">
                <img alt="" src={crossBlack} />
              </button>
              <div className="connect-exchange-scroll" ref={modalBodyRef}>
              <div className="onboardingContentBox top31px">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      width: 35,
                      height: 35,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    {community?.logo ? (
                      <img
                        src={community.logo}
                        alt={`${community?.disPlayName} logo`}
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <img
                        src={ProfileIcon}
                        alt="community logo"
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 900,
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      color: "#000",
                      fontFamily:
                        "Graphik Bold, -apple-system, BlinkMacSystemFont, sans-serif",
                    }}
                  >
                    {community?.disPlayName?.toUpperCase()}
                  </span>
                </div>
                {/* <p className="businessName">
                  {community?.disPlayName.toUpperCase()}
                </p> */}
                <h2 className="title">
                  <span>Connect exchange account</span>
                  <InfoPopup
                    contentItems={[
                      { text: "Invite VIP Members", type: "heading" },
                      {
                        text: "Turn this on to create a VIP subscription for your current lifetime(or just a longer access period) members at our cost price of $15/ month. If you define an end date for the VIP member then member will be offered to resubscribe at end of VIP membership. You can turn it off once you’ve onboarded all your VIP members without affecting their subscription.",
                        type: "paragraph",
                      },
                    ]}
                  />
                </h2>
                <p className="desc">This account will copy our trades</p>
                <div className="formBox">
                  <div className="mb-20px">
                    <div
                      className="customDropdown onboardingInput"
                      ref={dropdownRef}
                    >
                      <button
                        className="dropdownButton"
                        onClick={toggleDropdown}
                        ref={buttonRef}
                      >
                        <div className="inBtnFlexBox">
                          {selectedOption === "Select Exchange" ? (
                            selectedOption
                          ) : (
                            <>
                              {selectedOption.split(" ")[0]}
                              <span>
                                ({selectedOption.split(" ").splice(1).join(" ")}
                                )
                              </span>
                            </>
                          )}
                        </div>
                        <span
                          className={`dropdownArrow ${
                            isDropdownOpen && "rotate"
                          }`}
                        >
                          <img alt="" src={dropdownAngle} />
                        </span>
                      </button>
                      {isDropdownOpen && (
                        <div className="dropdownContent">
                          <p
                            onClick={() =>
                              handleOptionSelection("Binance Quick Connect")
                            }
                          >
                            <span className="span1">Binance</span>
                            <span>Quick Connect</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("Binance API Keys")
                            }
                          >
                            <span className="span1">Binance</span>
                            <span>API Keys</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("ByBit Quick Connect")
                            }
                          >
                            <span className="span1">ByBit</span>
                            <span>Quick Connect</span>
                          </p>
                          <p
                            onClick={() =>
                              handleOptionSelection("ByBit API Keys")
                            }
                          >
                            <span className="span1">ByBit</span>
                            <span>API Keys</span>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  {isApiKeySelected && (
                    <>
                      <div className="mb-20px">
                        <FloatingTextFiled
                          className="onboardingInput CM"
                          label="API Key"
                          onChange={(e) =>
                            setCredentials((pre) => ({
                              ...pre,
                              apiKey: e.target.value,
                            }))
                          }
                          placeholder="API Key"
                          value={credentials.apiKey}
                          // disabled={credentials.apiKey === "**********"}
                        />
                      </div>
                      <div className="mb-20px">
                        <FloatingTextFiled
                          className="onboardingInput CM"
                          label="Secret Key"
                          onChange={(e) =>
                            setCredentials((pre) => ({
                              ...pre,
                              secretKey: e.target.value,
                            }))
                          }
                          placeholder="Secret Key"
                          value={credentials.secretKey}
                          // disabled={credentials.secretKey === "**********"}
                        />
                      </div>
                      {selectedOption === "Binance API Keys" && (
                        <div className="mb-20px copyIpBox">
                          <FloatingTextFiled
                            className="onboardingInput CM"
                            disabled={true}
                            forLabel="binanceIp"
                            id="binanceIp"
                            label="IP"
                            onChange={() => {}}
                            placeholder="IP"
                            value={
                              ENV === "prod" ? "108.129.27.187" : "52.214.92.9"
                            }
                          />
                          <img
                            alt=""
                            className="copyIp"
                            onClick={() => {
                              navigator.clipboard
                                .writeText(
                                  ENV === "prod"
                                    ? "108.129.27.187"
                                    : "52.214.92.9",
                                )
                                .then(() => {
                                  toastify(
                                    "IP Address copied to clipboard!",
                                    "success",
                                  );
                                });
                            }}
                            src={Copy}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {(isApiKeySelected ||
                    selectedOption.includes("Quick Connect")) && (
                    <div ref={tradeMarketRef}>
                      <TradeMarketSegment
                        className="TradeMarketSegment--cm"
                        value={tradeMarketType}
                        onChange={setTradeMarketType}
                        recommendedValue={recommendedPermissionType}
                        recommendation={
                          recommendedPermissionType
                            ? {
                                label: MARKET_LABELS[recommendedPermissionType],
                                communityName,
                              }
                            : null
                        }
                        hint={
                          recommendedPermissionType
                            ? "Keep this selection, or switch if you prefer another market."
                            : "Choose which markets you’ll use with this connection."
                        }
                      />
                    </div>
                  )}
                  <BubbleSvgButton
                    className="NextBtnInv"
                    onClick={handleConnect}
                    text={"Next"}
                    type="button"
                    variant="black"
                    disabled={
                      (ENV !== "prod" &&
                        selectedOption.includes("Quick Connect")) ||
                      isLoading
                    }
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    mainDivStyle={{
                      width: "275px",
                      height: "55px",
                    }}
                  />
                </div>
              </div>
              </div>
              <div
                className={`paginationDots ${
                  selectedOption === "Binance API Keys" && "bottom-100px"
                }`}
              >
                <button className="dot"></button>
                <button className="dot active"></button>
                <button className="dot"></button>
                <button className="dot"></button>
                {/* <button className="dot"></button>
                <button className="dot"></button> */}
              </div>
              <div className="copyrightBox">
                <p className="">
                  Powered by
                  <span className="spanMain">
                    <img alt="" src={logo_black} />
                  </span>
                </p>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConnectExchange;